import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Link from '@eversports/klimt-primitives/legacy/Link'

import { UserProfileTabsPrefix } from '../../../../../App.types'
import ChevronLeft from '../../../../../assets/icons/chevron-left.svg'
import { useIntl } from '../../../../../localization/react'

const BackButton = () => {
  const intl = useIntl()
  return (
    <Link to={UserProfileTabsPrefix.OVERVIEW} external ariaLabel={intl.breadcrumbsMyBookings()}>
      <Box
        sx={{
          display: { xs: 'initial', md: 'none' },
          padding: 2,
          width: 'fit-content',
          height: 'fit-content',
          border: '1px solid',
          borderColor: 'mediumgray',
          borderRadius: 10,
          cursor: 'pointer',
          backgroundColor: 'white',
          boxShadow: boxShadows.default,
          position: 'absolute',
          top: '16px',
          left: '16px',
        }}
      >
        <Icon src={ChevronLeft} size="small" color="midnight" />
      </Box>
    </Link>
  )
}

export default BackButton
